export default __webpack_public_path__ + "static/media/rocket-hover.41c2b942.png";